import api from "./api";

export const getGlobalOperationsData = async () => {
    const [
        shipmentsRes,
        ordersRes,
        iotRes,
        blockchainRes,
        logsRes,
        notificationsRes,
        trustRes,
        predictiveRes,
    ] = await Promise.allSettled([
        api.get("/Shipment/all"),
        api.get("/orders/active"),
        api.get("/IoTDevice"),
        api.get("/BlockchainLog"),
        api.get("/SystemLog"),
        api.get("/notifications"),
        api.get("/TrustEngineV2/dashboard"),
        api.get("/PredictiveLogistics/dashboard"),
    ]);

    const getArray = (res) =>
        res.status === "fulfilled" && Array.isArray(res.value.data)
            ? res.value.data
            : [];

    const getObject = (res) =>
        res.status === "fulfilled" && res.value.data
            ? res.value.data
            : null;

    const shipments = getArray(shipmentsRes);
    const orders = getArray(ordersRes);
    const devices = getArray(iotRes);
    const blockchainLogs = getArray(blockchainRes);
    const logs = getArray(logsRes);
    const notifications = getArray(notificationsRes);

    const trust = getObject(trustRes);
    const predictive = getObject(predictiveRes);

    const onlineDevices = devices.filter((d) => {
        if (!d.lastUpdated) return false;
        return Date.now() - new Date(d.lastUpdated).getTime() < 2 * 60 * 1000;
    }).length;

    const criticalEvents = logs.filter((x) =>
        JSON.stringify(x).toLowerCase().includes("critical")
    ).length;

    return {
        shipments,
        orders,
        devices,
        blockchainLogs,
        logs,
        notifications,
        trust,
        predictive,

        activeShipments: shipments.length,
        activeOrders: orders.length,
        iotOnline: onlineDevices,
        iotTotal: devices.length,
        blockchainEvents: blockchainLogs.length,
        notificationsCount: notifications.length,
        criticalEvents,

        trustScore: trust?.overallTrustScore ?? 0,
        aiRisk: trust?.aiRiskScore ?? predictive?.aiRisk ?? 0,
        predictedDelays: predictive?.predictedDelays ?? 0,
        etaAccuracy: predictive?.etaAccuracy ?? 0,
    };
};